// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-image-block-full_container__N8VM8","wrapperImage":"business-hub-image-block-full_wrapperImage__sHN6K"};